import {
    GET_ACCOUNTS_OPENING,
    CREATE_ACCOUNTS_OPENING,
    UPDATE_ACCOUNTS_OPENING,
    DELETE_ACCOUNTS_OPENING,
    DOWNLOAD_ACCOUNTS_OPENING,
    BULK_UPLOAD_ACCOUNTS_OPENING,
    GET_GL_ACCOUNTS_OPENING,
    SAVE_GL_ACCOUNTS_OPENING,
    CLEAR_ACCOUNTS_OPENING_STATE,
} from '../../index.types';


export function getAccountsOpening(data) {
    return {
        type: GET_ACCOUNTS_OPENING,
        data
    }
}

export function createAccountsOpening(data) {
    return {
        type: CREATE_ACCOUNTS_OPENING,
        data
    }
}

export function updateAccountsOpening(data) {
    return {
        type: UPDATE_ACCOUNTS_OPENING,
        data
    }
}

export function deleteAccountsOpening(data) {
    return {
        type: DELETE_ACCOUNTS_OPENING,
        data
    }
}

export function downloadAccountsOpening(data) {
    return {
        type: DOWNLOAD_ACCOUNTS_OPENING,
        data
    }
}

export function bulkUploadAccountsOpening(data) {
    return {
        type: BULK_UPLOAD_ACCOUNTS_OPENING,
        data
    }
}

export function getGlAccountsOpening(data) {
    return {
        type: GET_GL_ACCOUNTS_OPENING,
        data
    }
}

export function saveGlAccountsOpening(data) {
    return {
        type: SAVE_GL_ACCOUNTS_OPENING,
        data
    }
}

export function clearAccountsOpeningState() {
    return {
        type: CLEAR_ACCOUNTS_OPENING_STATE
    }
}
